// extracted by mini-css-extract-plugin
export default {"headingText":"pendingApproval_headingText__lyj7D","subText":"pendingApproval_subText__4wkCt","slideTransition":"pendingApproval_slideTransition__foGmP"};